import { Component, OnDestroy } from '@angular/core';
import { ImpersonationAuthorizationDetailsDto } from '@capital-access/common/user';
import { CommonLocalizationModule } from '@capital-access/common/localization';
import { CommonFormattingModule } from '@capital-access/common/formatting';
import { FireflyDrawerContent } from '@capital-access/firefly/components';
import { ImpersonationDurationLocalizationKeyPipe } from './pipes/impersonation-duration-localization.pipe';
import { ImpersonationDuration } from '../../../models/impersonation-enums';

@Component({
  selector: 'ca-authorize-impersonation-readonly',
  standalone: true,
  imports: [CommonLocalizationModule, CommonFormattingModule, ImpersonationDurationLocalizationKeyPipe],
  templateUrl: './authorize-impersonation-readonly.component.html'
})
export class AuthorizeImpersonationReadonlyComponent extends FireflyDrawerContent<ImpersonationAuthorizationDetailsDto> {
  authorizeImpersonation!: ImpersonationAuthorizationDetailsDto;

  constructor() {
    super();
  }

  override onInjectInputs(input: ImpersonationAuthorizationDetailsDto): void {
    this.authorizeImpersonation = input;
  }

  getDurationKeyFromValue(days: number): string {
    const dayString = days.toString();
    const entry = Object.entries(ImpersonationDuration).find(([key, value]) => value === dayString);
    return entry ? entry[0] : dayString;
  }
}
